














































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { axiosM, resHandle } from "../../../../plugins/axios";
import { GetDictionary } from "@/request/moban";
import ShexiangMoban from "./systemMobans/shexiang.vue";
import ShexiangKeyanMoban from "./systemMobans/shexiang-keyan.vue";
import MianxiangMoban from "./systemMobans/mianxiang.vue";
import MaixiangMoban from "./systemMobans/maixiang.vue";
import ShoutuMoban from "./systemMobans/shoutu.vue";
import ToufatuMoban from "./systemMobans/toufatu.vue";
import LiangbiaoCmp from "./liangbiaoMobans/liangbiaoCmp.vue";
import Zhongyitizhi from "./systemMobans/zhongyitizhi.vue";
import Sizhenhecan from "./systemMobans/sizhenhecan.vue";
import Ertong from "./systemMobans/ertong.vue";
import Laonian from "./systemMobans/laonian.vue";
import Beiyun from "./systemMobans/beiyun.vue";
import Yunqi from "./systemMobans/yunqi.vue";
import Chanhou from "./systemMobans/chanhou.vue";
import Juejing from "./systemMobans/juejing.vue";
@Component({
  components: {
    ShexiangMoban,
    ShexiangKeyanMoban,
    MianxiangMoban,
    MaixiangMoban,
    ShoutuMoban,
    ToufatuMoban,
    LiangbiaoCmp,
    Zhongyitizhi,
    Sizhenhecan,
    Ertong,
    Laonian,
    Beiyun,
    Yunqi,
    Chanhou,
    Juejing,
  },
})
export default class SystemCmp extends Vue {
  @Prop()
  private cFangshi: any;
  @Prop()
  private groupName: any;
  @Prop()
  private isHideTop: any;
  private cMobanName: any = "舌象数据";
  private cMoban: any = {};
  private ziduans: any = {};
  private liangbiaoMoban: any[] = [];
  private cLiangbiao: any = {};
  /**
   * @description 返回分组页
   */
  private backToSecond() {
    this.$router.push(
      "/main/project/project-create-second/" + this.cFangshi.project_id
    );
  }
  /**
   * @description 返回模板列表页
   */
  private backToList() {
    this.$emit("cStateChange", "list");
  }
  /**
   * @description 从系统模板中找出当前模板
   */
  private findMoban() {
    if (!this.cMobanName) {
      return;
    }
    this.ziduans["系统模板"].map((moban: any) => {
      if (moban.title === this.cMobanName) {
        this.cMoban = moban;
      }
    });
  }
  /**
   * @description 获取后端保存的所有模板字段
   */
  private fetchZiduans() {
    const loading = this.$loading({
      body: true,
      text: "加载中...",
    });
    GetDictionary(this, "system")
      .then((data: any) => {
        this.ziduans = data;
        this.liangbiaoMoban = this.ziduans["量表模板"];
        this.findMoban();
      })
      .finally(() => {
        loading.close();
      });
  }
  /**
   * @description 切换为数据字典
   */
  private goToCustomMoban() {
    this.$emit("cStateChange", "custom");
  }
  /**
   * @description 切换自定义字段
   */
  private goToControl() {
    this.$emit("cStateChange", "control");
  }
  /**
   * @description 切换显示的模板
   */
  private changeMoban(name) {
    this.cMobanName = name;
    this.findMoban();
  }
  /**
   * @description 使用该模板
   */
  private useThisSystemMoban() {
    // console.log(this.cFangshi);
    // console.log(this.cMoban);
    if (this.cMoban.type === "量表数据") {
      const params: any = {
        project_id: this.cFangshi.project_id,
        group_id: this.cFangshi.group_id,
        interview_id: this.cFangshi.interview_id,
        名称: this.cMoban["title"],
        模板: this.cMoban["模板"],
        类别: "量表模板",
      };
      axios.post("api/project/template", params).then(({ data }) => {
        resHandle(this, data).then(() => {
          this.$message.success("使用模板成功");
          if (this.isHideTop) {
            this.$router.push({
              path: "/main/project/crf-list",
            });
          } else {
            this.$emit("cStateChange", "list");
          }
        });
      });
    } else {
      const params: any = {
        project_id: this.cFangshi.project_id,
        group_id: this.cFangshi.group_id,
        interview_id: this.cFangshi.interview_id,
        名称: this.cMoban["title"],
        模板: [this.cMoban],
        类别: "系统模板",
      };
      console.log(params);
      axios.post("api/project/template", params).then(({ data }) => {
        resHandle(this, data).then(() => {
          this.$message.success("使用模板成功");
          if (this.isHideTop) {
            this.$router.push({
              path: "/main/project/crf-list",
            });
          } else {
            this.$emit("cStateChange", "list");
          }
        });
      });
    }
  }
  /**
   * @description 选择一个量表模板
   */
  private changeLiangbiaoMoban(moban) {
    console.log(moban);
    this.cMobanName = "量表模板";
    this.cMoban = moban;
    this.$nextTick().then(() => {
      (this.$refs.resultWrap as any).scrollTop = 0;
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchZiduans();
  }
}
